module.exports = __webpack_public_path__ + "img/support-dude.213de4d5.svg";